import React from 'react'
import PropTypes from 'prop-types'
import ListCallToAction from '../ListCallToAction'
import styles from './styles'

const ListFooter = ({ hasOverlay, filtersSelected, totalCandidates }) => {
  return (
    <div className={hasOverlay ? styles.overlayContainer : styles.noOverlayContainer}>
      <ListCallToAction filtersSelected={filtersSelected} totalCandidates={totalCandidates} />
    </div>
  )
}

ListFooter.propTypes = {
  hasOverlay: PropTypes.bool,
  filtersSelected: PropTypes.object,
  totalCandidates: PropTypes.number,
}

export default ListFooter
